var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2372 15.7121C16.1878 15.7976 16.1168 15.8687 16.0312 15.918C15.9457 15.9674 15.8487 15.9934 15.7499 15.9934H2.24991C2.15122 15.9933 2.05429 15.9672 1.96886 15.9178C1.88343 15.8684 1.81251 15.7974 1.7632 15.7119C1.7139 15.6264 1.68796 15.5294 1.68799 15.4307C1.68801 15.332 1.714 15.2351 1.76335 15.1496C2.83421 13.2983 4.48444 11.9708 6.4103 11.3415C5.45769 10.7744 4.71756 9.91027 4.30359 8.88182C3.88962 7.85337 3.82469 6.71746 4.11878 5.64854C4.41286 4.57962 5.0497 3.63679 5.93149 2.96483C6.81328 2.29288 7.89127 1.92896 8.99991 1.92896C10.1086 1.92896 11.1865 2.29288 12.0683 2.96483C12.9501 3.63679 13.587 4.57962 13.881 5.64854C14.1751 6.71746 14.1102 7.85337 13.6962 8.88182C13.2823 9.91027 12.5421 10.7744 11.5895 11.3415C13.5154 11.9708 15.1656 13.2983 16.2365 15.1496C16.286 15.2351 16.3121 15.332 16.3122 15.4308C16.3123 15.5295 16.2864 15.6265 16.2372 15.7121Z",
    fill: "#297DF2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/user-blue.6c2ca688d4798ec1136c60209d837170.svg";
export { ForwardRef as ReactComponent };